module.exports = __webpack_public_path__ + "static/media/user-tie.904cd85d.svg";